import { useState, useEffect } from 'react'
import { createClient } from '@sanity/client'
import { fetchFounderData } from '../../api'
import { toast } from 'react-toastify'
import COPY from '../../utils/copy'

export default function Founder() {
  const [isLoading, setIsLoading] = useState(true)
  const [founderData, setFounderData] = useState<{
    name: string
    position: string
    description: string
    imageUrl: string
  } | null>(null)

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchFounderData)
      .then((data) => {
        setFounderData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    setIsLoading(false)
  }, [])

  return (
    <section
      id={COPY.ABOUT_ID}
      className='h-100% w-screen flex flex-col justify-center items-center bg-gray-50 py-6 sm:py-24'
    >
      {isLoading ? (
        <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
      ) : (
        <div className='flex flex-col justify-center items-center'>
          <img
            src={founderData?.imageUrl}
            alt={COPY.FOUNDER_ALT}
            className='rounded-full border-2 border-blue-600'
            height={128}
            width={128}
          />
          <p className='mt-8 mb-4 font-black text-3xl sm:text-5xl max-sm:px-4 text-center'>
            {founderData?.name}
          </p>
          <p className='mb-4 font-bold text-xl sm:text-2xl'>{founderData?.position}</p>
          <p className='font-medium text-base sm:text-xl xl:w-1/2 max-sm:px-4 max-xl:px-12 text-center leading-relaxed'>
            {founderData?.description}
          </p>
        </div>
      )}
    </section>
  )
}
